/**
 * Stylized input form
 */
import React, { Component } from 'react';
import styleBinder from 'classnames/bind';
import style from './input.module.css';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy class component (baseline)
export default class Input extends Component {
    render() {
        const { className, unbounded = false, inputRef, type, ...attrs } = this.props;
        const cx = styleBinder.bind(style);
        const inputStyle = cx('form-control', style.input, className, { unbounded });

        return type === 'textarea' ? (
            // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
            <textarea ref={inputRef} className={inputStyle} {...attrs} />
        ) : (
            // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
            <input ref={inputRef} className={inputStyle} type={type} {...attrs} />
        );
    }
}
